import { all, takeLatest } from 'redux-saga/effects';
import {
  DOWNLOAD_LEADS_REQUEST,
  FETCH_LEADS_REQUEST,
} from './constants';
import {
  fetchLeadSuccess,
  fetchLeadFail,
  downLoadLeadSuccess,
  downLoadLeadFail,
} from './actions';
import { authedApiSaga } from 'sagas';
import { getLeads, downloadLeads } from 'utils/api/leads';

const getFetchParams = (params) => {
  return params
    ? `?${Object.keys(params).map(k => params[k] ? `${k}=${params[k]}` : null).filter(x => x).join('&')}`
    : '';
}

export function* fetchLeadsFlow({ params }) {
  yield* authedApiSaga(token => getLeads(token, getFetchParams(params)), [], fetchLeadSuccess, fetchLeadFail);
}

export function* downloadLeadsFlow({ params }) {
  yield* authedApiSaga(token => downloadLeads(token, getFetchParams(params)),'', [], downLoadLeadSuccess, downLoadLeadFail);
}

export default function* watchChannels() {
  yield all([
    takeLatest(FETCH_LEADS_REQUEST, fetchLeadsFlow),
    takeLatest(DOWNLOAD_LEADS_REQUEST, downloadLeadsFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/containers/LeadsPage/sagas.js